export function getCityList() {
  const list = {
    '上海': [
      {
        'id': '5763',
        'level': 3,
        'name': '宝山区',
        'code': '0,1,5642,5643,5763,'
      },
      {
        'id': '5664',
        'level': 3,
        'name': '长宁区',
        'code': '0,1,5642,5643,5664,'
      },
      {
        'id': '5835',
        'level': 3,
        'name': '崇明区',
        'code': '0,1,5642,5643,5835,'
      },
      {
        'id': '5824',
        'level': 3,
        'name': '奉贤区',
        'code': '0,1,5642,5643,5824,'
      },
      {
        'id': '5727',
        'level': 3,
        'name': '虹口区',
        'code': '0,1,5642,5643,5727,'
      },
      {
        'id': '5699',
        'level': 3,
        'name': '黄浦区',
        'code': '0,1,5642,5643,5699,'
      },
      {
        'id': '5793',
        'level': 3,
        'name': '嘉定区',
        'code': '0,1,5642,5643,5793,'
      },
      {
        'id': '5812',
        'level': 3,
        'name': '金山区',
        'code': '0,1,5642,5643,5812,'
      },
      {
        'id': '5660',
        'level': 3,
        'name': '静安区',
        'code': '0,1,5642,5643,5660,'
      },
      {
        'id': '5644',
        'level': 3,
        'name': '卢湾区',
        'code': '0,1,5642,5643,5644,'
      },
      {
        'id': '5706',
        'level': 3,
        'name': '普陀区',
        'code': '0,1,5642,5643,5706,'
      },
      {
        'id': '5672',
        'level': 3,
        'name': '浦东新区',
        'code': '0,1,5642,5643,5672,'
      },
      {
        'id': '5805',
        'level': 3,
        'name': '青浦区',
        'code': '0,1,5642,5643,5805,'
      },
      {
        'id': '5776',
        'level': 3,
        'name': '松江区',
        'code': '0,1,5642,5643,5776,'
      },
      {
        'id': '5649',
        'level': 3,
        'name': '徐汇区',
        'code': '0,1,5642,5643,5649,'
      },
      {
        'id': '5736',
        'level': 3,
        'name': '杨浦区',
        'code': '0,1,5642,5643,5736,'
      },
      {
        'id': '5717',
        'level': 3,
        'name': '闸北区',
        'code': '0,1,5642,5643,5717,'
      },
      {
        'id': '5743',
        'level': 3,
        'name': '闵行区',
        'code': '0,1,5642,5643,5743,'
      }
    ],
    '北京': [
      {
        'id': '122',
        'level': 3,
        'name': '怀柔',
        'code': '0,1,2,3,122'
      },
      {
        'id': '123',
        'level': 3,
        'name': '近郊其它',
        'code': '0,1,2,3,123'
      },
      {
        'id': '124',
        'level': 3,
        'name': '门头沟',
        'code': '0,1,2,3,124'
      },
      {
        'id': '125',
        'level': 3,
        'name': '平谷',
        'code': '0,1,2,3,125'
      },
      {
        'id': '126',
        'level': 3,
        'name': '密云县',
        'code': '0,1,2,3,126'
      },
      {
        'id': '127',
        'level': 3,
        'name': '延庆县',
        'code': '0,1,2,3,127'
      },
      {
        'id': '162',
        'level': 3,
        'name': '昌平区',
        'code': '0,1,2,3,162,'
      },
      {
        'id': '4',
        'level': 3,
        'name': '朝阳区',
        'code': '0,1,2,3,4,'
      },
      {
        'id': '157',
        'level': 3,
        'name': '大兴区',
        'code': '0,1,2,3,157,'
      },
      {
        'id': '55',
        'level': 3,
        'name': '东城区',
        'code': '0,1,2,3,55,'
      },
      {
        'id': '178',
        'level': 3,
        'name': '房山区',
        'code': '0,1,2,3,178,'
      },
      {
        'id': '128',
        'level': 3,
        'name': '丰台区',
        'code': '0,1,2,3,128,'
      },
      {
        'id': '74',
        'level': 3,
        'name': '海淀区',
        'code': '0,1,2,3,74,'
      },
      {
        'id': '121',
        'level': 3,
        'name': '近郊',
        'code': '0,1,2,3,121,'
      },
      {
        'id': '151',
        'level': 3,
        'name': '石景山区',
        'code': '0,1,2,3,151,'
      },
      {
        'id': '180',
        'level': 3,
        'name': '顺义区',
        'code': '0,1,2,3,180,'
      },
      {
        'id': '170',
        'level': 3,
        'name': '通州区',
        'code': '0,1,2,3,170,'
      },
      {
        'id': '101',
        'level': 3,
        'name': '西城区',
        'code': '0,1,2,3,101,'
      }
    ],
    '天津': [
      {
        'id': '6148',
        'level': 3,
        'name': '东丽区',
        'code': '0,1,6089,6090,6148'
      },
      {
        'id': '6149',
        'level': 3,
        'name': '津南区',
        'code': '0,1,6089,6090,6149'
      },
      {
        'id': '6150',
        'level': 3,
        'name': '北辰区',
        'code': '0,1,6089,6090,6150'
      },
      {
        'id': '6151',
        'level': 3,
        'name': '武清区',
        'code': '0,1,6089,6090,6151'
      },
      {
        'id': '6152',
        'level': 3,
        'name': '宝坻区',
        'code': '0,1,6089,6090,6152'
      },
      {
        'id': '6153',
        'level': 3,
        'name': '蓟县',
        'code': '0,1,6089,6090,6153'
      },
      {
        'id': '6154',
        'level': 3,
        'name': '宁河县',
        'code': '0,1,6089,6090,6154'
      },
      {
        'id': '6155',
        'level': 3,
        'name': '静海县',
        'code': '0,1,6089,6090,6155'
      },
      {
        'id': '6165',
        'level': 3,
        'name': '滨海新区',
        'code': '0,1,6089,6090,6165,'
      },
      {
        'id': '6091',
        'level': 3,
        'name': '和平区',
        'code': '0,1,6089,6090,6091,'
      },
      {
        'id': '6099',
        'level': 3,
        'name': '河北区',
        'code': '0,1,6089,6090,6099,'
      },
      {
        'id': '6107',
        'level': 3,
        'name': '河东区',
        'code': '0,1,6089,6090,6107,'
      },
      {
        'id': '6119',
        'level': 3,
        'name': '河西区',
        'code': '0,1,6089,6090,6119,'
      },
      {
        'id': '6156',
        'level': 3,
        'name': '红桥区',
        'code': '0,1,6089,6090,6156,'
      },
      {
        'id': '6147',
        'level': 3,
        'name': '近郊',
        'code': '0,1,6089,6090,6147,'
      },
      {
        'id': '6132',
        'level': 3,
        'name': '南开区',
        'code': '0,1,6089,6090,6132,'
      },
      {
        'id': '6181',
        'level': 3,
        'name': '西青区',
        'code': '0,1,6089,6090,6181,'
      }
    ],
    '重庆': [
      {
        'id': '7085',
        'level': 3,
        'name': '潼南县',
        'code': '0,1,7006,7007,7085'
      },
      {
        'id': '7086',
        'level': 3,
        'name': '铜梁县',
        'code': '0,1,7006,7007,7086'
      },
      {
        'id': '7087',
        'level': 3,
        'name': '南川区',
        'code': '0,1,7006,7007,7087'
      },
      {
        'id': '7088',
        'level': 3,
        'name': '綦江区',
        'code': '0,1,7006,7007,7088'
      },
      {
        'id': '7089',
        'level': 3,
        'name': '璧山县',
        'code': '0,1,7006,7007,7089'
      },
      {
        'id': '7090',
        'level': 3,
        'name': '垫江县',
        'code': '0,1,7006,7007,7090'
      },
      {
        'id': '7091',
        'level': 3,
        'name': '大足区',
        'code': '0,1,7006,7007,7091'
      },
      {
        'id': '7092',
        'level': 3,
        'name': '荣昌县',
        'code': '0,1,7006,7007,7092'
      },
      {
        'id': '7093',
        'level': 3,
        'name': '黔江区',
        'code': '0,1,7006,7007,7093'
      },
      {
        'id': '7094',
        'level': 3,
        'name': '开县',
        'code': '0,1,7006,7007,7094,'
      },
      {
        'id': '7095',
        'level': 3,
        'name': '巫溪县',
        'code': '0,1,7006,7007,7095'
      },
      {
        'id': '7096',
        'level': 3,
        'name': '巫山县',
        'code': '0,1,7006,7007,7096'
      },
      {
        'id': '7097',
        'level': 3,
        'name': '奉节县',
        'code': '0,1,7006,7007,7097'
      },
      {
        'id': '7098',
        'level': 3,
        'name': '武隆县',
        'code': '0,1,7006,7007,7098'
      },
      {
        'id': '7099',
        'level': 3,
        'name': '丰都县',
        'code': '0,1,7006,7007,7099'
      },
      {
        'id': '7100',
        'level': 3,
        'name': '城口县',
        'code': '0,1,7006,7007,7100'
      },
      {
        'id': '7101',
        'level': 3,
        'name': '梁平区',
        'code': '0,1,7006,7007,7101'
      },
      {
        'id': '7102',
        'level': 3,
        'name': '酉阳土家族苗族自治县',
        'code': '0,1,7006,7007,7102'
      },
      {
        'id': '7103',
        'level': 3,
        'name': '秀山土家族苗族自治县',
        'code': '0,1,7006,7007,7103'
      },
      {
        'id': '7104',
        'level': 3,
        'name': '云阳县',
        'code': '0,1,7006,7007,7104,'
      },
      {
        'id': '7105',
        'level': 3,
        'name': '忠县',
        'code': '0,1,7006,7007,7105'
      },
      {
        'id': '7106',
        'level': 3,
        'name': '石柱土家族自治县',
        'code': '0,1,7006,7007,7106'
      },
      {
        'id': '7107',
        'level': 3,
        'name': '彭水苗族土家族自治县',
        'code': '0,1,7006,7007,7107'
      },
      {
        'id': '7235',
        'level': 3,
        'name': '奉节县',
        'code': '0,1,7006,7007,7235,'
      },
      {
        'id': '7237',
        'level': 3,
        'name': '秀山县',
        'code': '0,1,7006,7007,7237,'
      },
      {
        'id': '7239',
        'level': 3,
        'name': '彭水',
        'code': '0,1,7006,7007,7239,'
      },
      {
        'id': '7111',
        'level': 3,
        'name': '巴南区',
        'code': '0,1,7006,7007,7111,'
      },
      {
        'id': '7115',
        'level': 3,
        'name': '北碚区',
        'code': '0,1,7006,7007,7115,'
      },
      {
        'id': '7143',
        'level': 3,
        'name': '长寿区',
        'code': '0,1,7006,7007,7143,'
      },
      {
        'id': '7108',
        'level': 3,
        'name': '大渡口区',
        'code': '0,1,7006,7007,7108,'
      },
      {
        'id': '7122',
        'level': 3,
        'name': '涪陵区',
        'code': '0,1,7006,7007,7122,'
      },
      {
        'id': '7150',
        'level': 3,
        'name': '合川区',
        'code': '0,1,7006,7007,7150,'
      },
      {
        'id': '7059',
        'level': 3,
        'name': '江北区',
        'code': '0,1,7006,7007,7059,'
      },
      {
        'id': '7138',
        'level': 3,
        'name': '江津区',
        'code': '0,1,7006,7007,7138,'
      },
      {
        'id': '7084',
        'level': 3,
        'name': '近郊',
        'code': '0,1,7006,7007,7084,'
      },
      {
        'id': '7048',
        'level': 3,
        'name': '九龙坡区',
        'code': '0,1,7006,7007,7048,'
      },
      {
        'id': '7037',
        'level': 3,
        'name': '南岸区',
        'code': '0,1,7006,7007,7037,'
      },
      {
        'id': '7021',
        'level': 3,
        'name': '沙坪坝区',
        'code': '0,1,7006,7007,7021,'
      },
      {
        'id': '7131',
        'level': 3,
        'name': '万州区',
        'code': '0,1,7006,7007,7131,'
      },
      {
        'id': '7135',
        'level': 3,
        'name': '永川区',
        'code': '0,1,7006,7007,7135,'
      },
      {
        'id': '7067',
        'level': 3,
        'name': '渝北区',
        'code': '0,1,7006,7007,7067,'
      },
      {
        'id': '7008',
        'level': 3,
        'name': '渝中区',
        'code': '0,1,7006,7007,7008,'
      }
    ],
    '安徽': [
      {
        'id': '184',
        'level': 2,
        'name': '安庆',
        'code': '0,1,183,184,'
      },
      {
        'id': '185',
        'level': 2,
        'name': '蚌埠',
        'code': '0,1,183,185,'
      },
      {
        'id': '202',
        'level': 2,
        'name': '巢湖',
        'code': '0,1,183,202,'
      },
      {
        'id': '203',
        'level': 2,
        'name': '池州',
        'code': '0,1,183,203,'
      },
      {
        'id': '204',
        'level': 2,
        'name': '滁州',
        'code': '0,1,183,204,'
      },
      {
        'id': '219',
        'level': 2,
        'name': '阜阳',
        'code': '0,1,183,219,'
      },
      {
        'id': '372',
        'level': 2,
        'name': '合肥',
        'code': '0,1,183,372,'
      },
      {
        'id': '240',
        'level': 2,
        'name': '淮北',
        'code': '0,1,183,240,'
      },
      {
        'id': '251',
        'level': 2,
        'name': '淮南',
        'code': '0,1,183,251,'
      },
      {
        'id': '266',
        'level': 2,
        'name': '黄山',
        'code': '0,1,183,266,'
      },
      {
        'id': '267',
        'level': 2,
        'name': '六安',
        'code': '0,1,183,267,'
      },
      {
        'id': '268',
        'level': 2,
        'name': '马鞍山',
        'code': '0,1,183,268,'
      },
      {
        'id': '284',
        'level': 2,
        'name': '宿州',
        'code': '0,1,183,284,'
      },
      {
        'id': '285',
        'level': 2,
        'name': '铜陵',
        'code': '0,1,183,285,'
      },
      {
        'id': '293',
        'level': 2,
        'name': '芜湖',
        'code': '0,1,183,293,'
      },
      {
        'id': '358',
        'level': 2,
        'name': '宣城',
        'code': '0,1,183,358,'
      },
      {
        'id': '371',
        'level': 2,
        'name': '亳州',
        'code': '0,1,183,371,'
      }
    ],
    '澳门': [
      {
        'id': '7217',
        'level': 3,
        'name': '半岛',
        'code': '0,1,7215,7216,7217,'
      },
      {
        'id': '7228',
        'level': 3,
        'name': '离岛',
        'code': '0,1,7215,7216,7228,'
      }
    ],
    '江西': [
      {
        'id': '4145',
        'level': 2,
        'name': '抚州',
        'code': '0,1,4084,4145,'
      },
      {
        'id': '4171',
        'level': 2,
        'name': '赣州',
        'code': '0,1,4084,4171,'
      },
      {
        'id': '4174',
        'level': 2,
        'name': '吉安',
        'code': '0,1,4084,4174,'
      },
      {
        'id': '4175',
        'level': 2,
        'name': '景德镇',
        'code': '0,1,4084,4175,'
      },
      {
        'id': '4176',
        'level': 2,
        'name': '九江',
        'code': '0,1,4084,4176,'
      },
      {
        'id': '4085',
        'level': 2,
        'name': '南昌',
        'code': '0,1,4084,4085,'
      },
      {
        'id': '4222',
        'level': 2,
        'name': '萍乡',
        'code': '0,1,4084,4222,'
      },
      {
        'id': '4223',
        'level': 2,
        'name': '上饶',
        'code': '0,1,4084,4223,'
      },
      {
        'id': '4224',
        'level': 2,
        'name': '新余',
        'code': '0,1,4084,4224,'
      },
      {
        'id': '4225',
        'level': 2,
        'name': '宜春',
        'code': '0,1,4084,4225,'
      },
      {
        'id': '4226',
        'level': 2,
        'name': '鹰潭',
        'code': '0,1,4084,4226,'
      }
    ],
    '江苏': [
      {
        'id': '3556',
        'level': 2,
        'name': '常州',
        'code': '0,1,3320,3556,'
      },
      {
        'id': '3681',
        'level': 2,
        'name': '淮安',
        'code': '0,1,3320,3681,'
      },
      {
        'id': '3721',
        'level': 2,
        'name': '连云港',
        'code': '0,1,3320,3721,'
      },
      {
        'id': '3321',
        'level': 2,
        'name': '南京',
        'code': '0,1,3320,3321,'
      },
      {
        'id': '3739',
        'level': 2,
        'name': '南通',
        'code': '0,1,3320,3739,'
      },
      {
        'id': '3382',
        'level': 2,
        'name': '苏州',
        'code': '0,1,3320,3382,'
      },
      {
        'id': '3798',
        'level': 2,
        'name': '宿迁',
        'code': '0,1,3320,3798,'
      },
      {
        'id': '3801',
        'level': 2,
        'name': '泰州',
        'code': '0,1,3320,3801,'
      },
      {
        'id': '3448',
        'level': 2,
        'name': '无锡',
        'code': '0,1,3320,3448,'
      },
      {
        'id': '3853',
        'level': 2,
        'name': '徐州',
        'code': '0,1,3320,3853,'
      },
      {
        'id': '3930',
        'level': 2,
        'name': '盐城',
        'code': '0,1,3320,3930,'
      },
      {
        'id': '3988',
        'level': 2,
        'name': '扬州',
        'code': '0,1,3320,3988,'
      },
      {
        'id': '4045',
        'level': 2,
        'name': '镇江',
        'code': '0,1,3320,4045,'
      }
    ],
    '内蒙古': [
      {
        'id': '4536',
        'level': 2,
        'name': '阿拉善盟',
        'code': '0,1,4493,4536,'
      },
      {
        'id': '4537',
        'level': 2,
        'name': '巴彦淖尔',
        'code': '0,1,4493,4537,'
      },
      {
        'id': '4538',
        'level': 2,
        'name': '包头',
        'code': '0,1,4493,4538,'
      },
      {
        'id': '4574',
        'level': 2,
        'name': '赤峰',
        'code': '0,1,4493,4574,'
      },
      {
        'id': '4575',
        'level': 2,
        'name': '鄂尔多斯',
        'code': '0,1,4493,4575,'
      },
      {
        'id': '4494',
        'level': 2,
        'name': '呼和浩特',
        'code': '0,1,4493,4494,'
      },
      {
        'id': '4583',
        'level': 2,
        'name': '呼伦贝尔',
        'code': '0,1,4493,4583,'
      },
      {
        'id': '4584',
        'level': 2,
        'name': '通辽',
        'code': '0,1,4493,4584,'
      },
      {
        'id': '4585',
        'level': 2,
        'name': '乌海',
        'code': '0,1,4493,4585,'
      },
      {
        'id': '4586',
        'level': 2,
        'name': '乌兰察布市',
        'code': '0,1,4493,4586,'
      },
      {
        'id': '4587',
        'level': 2,
        'name': '锡林郭勒盟',
        'code': '0,1,4493,4587,'
      },
      {
        'id': '4588',
        'level': 2,
        'name': '兴安盟',
        'code': '0,1,4493,4588,'
      }
    ],
    '辽宁': [
      {
        'id': '4323',
        'level': 2,
        'name': '鞍山',
        'code': '0,1,4227,4323,'
      },
      {
        'id': '4349',
        'level': 2,
        'name': '本溪',
        'code': '0,1,4227,4349,'
      },
      {
        'id': '4350',
        'level': 2,
        'name': '朝阳',
        'code': '0,1,4227,4350,'
      },
      {
        'id': '4279',
        'level': 2,
        'name': '大连',
        'code': '0,1,4227,4279,'
      },
      {
        'id': '4351',
        'level': 2,
        'name': '丹东',
        'code': '0,1,4227,4351,'
      },
      {
        'id': '4358',
        'level': 2,
        'name': '抚顺',
        'code': '0,1,4227,4358,'
      },
      {
        'id': '4383',
        'level': 2,
        'name': '阜新',
        'code': '0,1,4227,4383,'
      },
      {
        'id': '4384',
        'level': 2,
        'name': '葫芦岛',
        'code': '0,1,4227,4384,'
      },
      {
        'id': '4385',
        'level': 2,
        'name': '锦州',
        'code': '0,1,4227,4385,'
      },
      {
        'id': '4427',
        'level': 2,
        'name': '辽阳',
        'code': '0,1,4227,4427,'
      },
      {
        'id': '4428',
        'level': 2,
        'name': '盘锦',
        'code': '0,1,4227,4428,'
      },
      {
        'id': '4228',
        'level': 2,
        'name': '沈阳',
        'code': '0,1,4227,4228,'
      },
      {
        'id': '4441',
        'level': 2,
        'name': '铁岭',
        'code': '0,1,4227,4441,'
      },
      {
        'id': '4451',
        'level': 2,
        'name': '营口',
        'code': '0,1,4227,4451,'
      }
    ],
    '福建': [
      {
        'id': '442',
        'level': 2,
        'name': '福州',
        'code': '0,1,441,442,'
      },
      {
        'id': '495',
        'level': 2,
        'name': '龙岩',
        'code': '0,1,441,495,'
      },
      {
        'id': '512',
        'level': 2,
        'name': '南平',
        'code': '0,1,441,512,'
      },
      {
        'id': '513',
        'level': 2,
        'name': '宁德',
        'code': '0,1,441,513,'
      },
      {
        'id': '547',
        'level': 2,
        'name': '莆田',
        'code': '0,1,441,547,'
      },
      {
        'id': '577',
        'level': 2,
        'name': '泉州',
        'code': '0,1,441,577,'
      },
      {
        'id': '623',
        'level': 2,
        'name': '三明',
        'code': '0,1,441,623,'
      },
      {
        'id': '624',
        'level': 2,
        'name': '厦门',
        'code': '0,1,441,624,'
      },
      {
        'id': '665',
        'level': 2,
        'name': '漳州',
        'code': '0,1,441,665,'
      }
    ],
    '甘肃': [
      {
        'id': '781',
        'level': 2,
        'name': '白银',
        'code': '0,1,700,781,'
      },
      {
        'id': '782',
        'level': 2,
        'name': '定西',
        'code': '0,1,700,782,'
      },
      {
        'id': '783',
        'level': 2,
        'name': '甘南',
        'code': '0,1,700,783,'
      },
      {
        'id': '784',
        'level': 2,
        'name': '嘉峪关',
        'code': '0,1,700,784,'
      },
      {
        'id': '785',
        'level': 2,
        'name': '金昌',
        'code': '0,1,700,785,'
      },
      {
        'id': '786',
        'level': 2,
        'name': '酒泉',
        'code': '0,1,700,786,'
      },
      {
        'id': '701',
        'level': 2,
        'name': '兰州',
        'code': '0,1,700,701,'
      },
      {
        'id': '787',
        'level': 2,
        'name': '临夏',
        'code': '0,1,700,787,'
      },
      {
        'id': '788',
        'level': 2,
        'name': '陇南',
        'code': '0,1,700,788,'
      },
      {
        'id': '789',
        'level': 2,
        'name': '平凉',
        'code': '0,1,700,789,'
      },
      {
        'id': '790',
        'level': 2,
        'name': '庆阳',
        'code': '0,1,700,790,'
      },
      {
        'id': '791',
        'level': 2,
        'name': '天水',
        'code': '0,1,700,791,'
      },
      {
        'id': '792',
        'level': 2,
        'name': '武威',
        'code': '0,1,700,792,'
      },
      {
        'id': '793',
        'level': 2,
        'name': '张掖',
        'code': '0,1,700,793,'
      }
    ],
    '广东': [
      {
        'id': '976',
        'level': 2,
        'name': '潮州',
        'code': '0,1,794,976,'
      },
      {
        'id': '977',
        'level': 2,
        'name': '东莞',
        'code': '0,1,794,977,'
      },
      {
        'id': '795',
        'level': 2,
        'name': '广州',
        'code': '0,1,794,795,'
      },
      {
        'id': '1130',
        'level': 2,
        'name': '佛山',
        'code': '0,1,794,1130,'
      },
      {
        'id': '888',
        'level': 2,
        'name': '深圳',
        'code': '0,1,794,888,'
      },
      {
        'id': '1178',
        'level': 2,
        'name': '河源',
        'code': '0,1,794,1178,'
      },
      {
        'id': '1179',
        'level': 2,
        'name': '惠州',
        'code': '0,1,794,1179,'
      },
      {
        'id': '1233',
        'level': 2,
        'name': '江门',
        'code': '0,1,794,1233,'
      },
      {
        'id': '1264',
        'level': 2,
        'name': '揭阳',
        'code': '0,1,794,1264,'
      },
      {
        'id': '1265',
        'level': 2,
        'name': '茂名',
        'code': '0,1,794,1265,'
      },
      {
        'id': '1318',
        'level': 2,
        'name': '梅州',
        'code': '0,1,794,1318,'
      },
      {
        'id': '1319',
        'level': 2,
        'name': '清远',
        'code': '0,1,794,1319,'
      },
      {
        'id': '1358',
        'level': 2,
        'name': '汕头',
        'code': '0,1,794,1358,'
      },
      {
        'id': '1380',
        'level': 2,
        'name': '汕尾',
        'code': '0,1,794,1380,'
      },
      {
        'id': '1381',
        'level': 2,
        'name': '韶关',
        'code': '0,1,794,1381,'
      },
      {
        'id': '1409',
        'level': 2,
        'name': '阳江',
        'code': '0,1,794,1409,'
      },
      {
        'id': '1424',
        'level': 2,
        'name': '云浮',
        'code': '0,1,794,1424,'
      },
      {
        'id': '1425',
        'level': 2,
        'name': '湛江',
        'code': '0,1,794,1425,'
      },
      {
        'id': '1462',
        'level': 2,
        'name': '肇庆',
        'code': '0,1,794,1462,'
      },
      {
        'id': '1474',
        'level': 2,
        'name': '中山',
        'code': '0,1,794,1474,'
      },
      {
        'id': '1535',
        'level': 2,
        'name': '珠海',
        'code': '0,1,794,1535,'
      }
    ],
    '广西': [
      {
        'id': '1668',
        'level': 2,
        'name': '百色',
        'code': '0,1,1551,1668,'
      },
      {
        'id': '1669',
        'level': 2,
        'name': '北海',
        'code': '0,1,1551,1669,'
      },
      {
        'id': '1672',
        'level': 2,
        'name': '崇左',
        'code': '0,1,1551,1672,'
      },
      {
        'id': '1673',
        'level': 2,
        'name': '防城港',
        'code': '0,1,1551,1673,'
      },
      {
        'id': '1629',
        'level': 2,
        'name': '桂林',
        'code': '0,1,1551,1629,'
      },
      {
        'id': '1674',
        'level': 2,
        'name': '贵港',
        'code': '0,1,1551,1674,'
      },
      {
        'id': '1675',
        'level': 2,
        'name': '河池',
        'code': '0,1,1551,1675,'
      },
      {
        'id': '1676',
        'level': 2,
        'name': '贺州',
        'code': '0,1,1551,1676,'
      },
      {
        'id': '1677',
        'level': 2,
        'name': '来宾',
        'code': '0,1,1551,1677,'
      },
      {
        'id': '1684',
        'level': 2,
        'name': '柳州',
        'code': '0,1,1551,1684,'
      },
      {
        'id': '1552',
        'level': 2,
        'name': '南宁',
        'code': '0,1,1551,1552,'
      },
      {
        'id': '1715',
        'level': 2,
        'name': '钦州',
        'code': '0,1,1551,1715,'
      },
      {
        'id': '1716',
        'level': 2,
        'name': '梧州',
        'code': '0,1,1551,1716,'
      },
      {
        'id': '1719',
        'level': 2,
        'name': '玉林',
        'code': '0,1,1551,1719,'
      }
    ],
    '贵州': [
      {
        'id': '1814',
        'level': 2,
        'name': '安顺',
        'code': '0,1,1720,1814,'
      },
      {
        'id': '1815',
        'level': 2,
        'name': '毕节',
        'code': '0,1,1720,1815,'
      },
      {
        'id': '1721',
        'level': 2,
        'name': '贵阳',
        'code': '0,1,1720,1721,'
      },
      {
        'id': '1816',
        'level': 2,
        'name': '六盘水',
        'code': '0,1,1720,1816,'
      },
      {
        'id': '1817',
        'level': 2,
        'name': '黔东南',
        'code': '0,1,1720,1817,'
      },
      {
        'id': '1818',
        'level': 2,
        'name': '黔南',
        'code': '0,1,1720,1818,'
      },
      {
        'id': '1819',
        'level': 2,
        'name': '黔西南',
        'code': '0,1,1720,1819,'
      },
      {
        'id': '1820',
        'level': 2,
        'name': '铜仁',
        'code': '0,1,1720,1820,'
      },
      {
        'id': '1821',
        'level': 2,
        'name': '遵义',
        'code': '0,1,1720,1821,'
      }
    ],
    '海南': [
      {
        'id': '1935',
        'level': 2,
        'name': '白沙',
        'code': '0,1,1866,1935,'
      },
      {
        'id': '1936',
        'level': 2,
        'name': '保亭',
        'code': '0,1,1866,1936,'
      },
      {
        'id': '1937',
        'level': 2,
        'name': '昌江',
        'code': '0,1,1866,1937,'
      },
      {
        'id': '1938',
        'level': 2,
        'name': '澄迈县',
        'code': '0,1,1866,1938,'
      },
      {
        'id': '1939',
        'level': 2,
        'name': '定安县',
        'code': '0,1,1866,1939,'
      },
      {
        'id': '1940',
        'level': 2,
        'name': '东方',
        'code': '0,1,1866,1940,'
      },
      {
        'id': '1867',
        'level': 2,
        'name': '海口',
        'code': '0,1,1866,1867,'
      },
      {
        'id': '1941',
        'level': 2,
        'name': '乐东',
        'code': '0,1,1866,1941,'
      },
      {
        'id': '1942',
        'level': 2,
        'name': '临高县',
        'code': '0,1,1866,1942,'
      },
      {
        'id': '1943',
        'level': 2,
        'name': '陵水',
        'code': '0,1,1866,1943,'
      },
      {
        'id': '1944',
        'level': 2,
        'name': '琼海',
        'code': '0,1,1866,1944,'
      },
      {
        'id': '1947',
        'level': 2,
        'name': '琼中',
        'code': '0,1,1866,1947,'
      },
      {
        'id': '1912',
        'level': 2,
        'name': '三亚',
        'code': '0,1,1866,1912,'
      },
      {
        'id': '1948',
        'level': 2,
        'name': '屯昌县',
        'code': '0,1,1866,1948,'
      },
      {
        'id': '1949',
        'level': 2,
        'name': '万宁',
        'code': '0,1,1866,1949,'
      },
      {
        'id': '1950',
        'level': 2,
        'name': '文昌',
        'code': '0,1,1866,1950,'
      },
      {
        'id': '1953',
        'level': 2,
        'name': '五指山',
        'code': '0,1,1866,1953,'
      },
      {
        'id': '1954',
        'level': 2,
        'name': '儋州',
        'code': '0,1,1866,1954,'
      }
    ],
    '河北': [
      {
        'id': '2033',
        'level': 2,
        'name': '保定',
        'code': '0,1,1957,2033,'
      },
      {
        'id': '2092',
        'level': 2,
        'name': '沧州',
        'code': '0,1,1957,2092,'
      },
      {
        'id': '2093',
        'level': 2,
        'name': '承德',
        'code': '0,1,1957,2093,'
      },
      {
        'id': '2099',
        'level': 2,
        'name': '邯郸',
        'code': '0,1,1957,2099,'
      },
      {
        'id': '2166',
        'level': 2,
        'name': '衡水',
        'code': '0,1,1957,2166,'
      },
      {
        'id': '2167',
        'level': 2,
        'name': '廊坊',
        'code': '0,1,1957,2167,'
      },
      {
        'id': '2199',
        'level': 2,
        'name': '秦皇岛',
        'code': '0,1,1957,2199,'
      },
      {
        'id': '1958',
        'level': 2,
        'name': '石家庄',
        'code': '0,1,1957,1958,'
      },
      {
        'id': '2247',
        'level': 2,
        'name': '唐山',
        'code': '0,1,1957,2247,'
      },
      {
        'id': '2300',
        'level': 2,
        'name': '邢台',
        'code': '0,1,1957,2300,'
      },
      {
        'id': '2309',
        'level': 2,
        'name': '张家口',
        'code': '0,1,1957,2309,'
      }
    ],
    '河南': [
      {
        'id': '2445',
        'level': 2,
        'name': '安阳',
        'code': '0,1,2321,2445,'
      },
      {
        'id': '2446',
        'level': 2,
        'name': '鹤壁',
        'code': '0,1,2321,2446,'
      },
      {
        'id': '2447',
        'level': 2,
        'name': '济源',
        'code': '0,1,2321,2447,'
      },
      {
        'id': '2448',
        'level': 2,
        'name': '焦作',
        'code': '0,1,2321,2448,'
      },
      {
        'id': '2423',
        'level': 2,
        'name': '开封',
        'code': '0,1,2321,2423,'
      },
      {
        'id': '2376',
        'level': 2,
        'name': '洛阳',
        'code': '0,1,2321,2376,'
      },
      {
        'id': '2486',
        'level': 2,
        'name': '南阳',
        'code': '0,1,2321,2486,'
      },
      {
        'id': '2509',
        'level': 2,
        'name': '平顶山',
        'code': '0,1,2321,2509,'
      },
      {
        'id': '2531',
        'level': 2,
        'name': '三门峡',
        'code': '0,1,2321,2531,'
      },
      {
        'id': '2532',
        'level': 2,
        'name': '商丘',
        'code': '0,1,2321,2532,'
      },
      {
        'id': '2533',
        'level': 2,
        'name': '新乡',
        'code': '0,1,2321,2533,'
      },
      {
        'id': '2560',
        'level': 2,
        'name': '信阳',
        'code': '0,1,2321,2560,'
      },
      {
        'id': '2561',
        'level': 2,
        'name': '许昌',
        'code': '0,1,2321,2561,'
      },
      {
        'id': '2322',
        'level': 2,
        'name': '郑州',
        'code': '0,1,2321,2322,'
      },
      {
        'id': '2562',
        'level': 2,
        'name': '周口',
        'code': '0,1,2321,2562,'
      },
      {
        'id': '2563',
        'level': 2,
        'name': '驻马店',
        'code': '0,1,2321,2563,'
      },
      {
        'id': '2564',
        'level': 2,
        'name': '漯河',
        'code': '0,1,2321,2564,'
      },
      {
        'id': '2565',
        'level': 2,
        'name': '濮阳',
        'code': '0,1,2321,2565,'
      }
    ],
    '黑龙江': [
      {
        'id': '2622',
        'level': 2,
        'name': '大庆',
        'code': '0,1,2568,2622,'
      },
      {
        'id': '2650',
        'level': 2,
        'name': '大兴安岭',
        'code': '0,1,2568,2650,'
      },
      {
        'id': '2569',
        'level': 2,
        'name': '哈尔滨',
        'code': '0,1,2568,2569,'
      },
      {
        'id': '2651',
        'level': 2,
        'name': '鹤岗',
        'code': '0,1,2568,2651,'
      },
      {
        'id': '2652',
        'level': 2,
        'name': '黑河',
        'code': '0,1,2568,2652,'
      },
      {
        'id': '2653',
        'level': 2,
        'name': '鸡西',
        'code': '0,1,2568,2653,'
      },
      {
        'id': '2654',
        'level': 2,
        'name': '佳木斯',
        'code': '0,1,2568,2654,'
      },
      {
        'id': '2655',
        'level': 2,
        'name': '牡丹江',
        'code': '0,1,2568,2655,'
      },
      {
        'id': '2656',
        'level': 2,
        'name': '七台河',
        'code': '0,1,2568,2656,'
      },
      {
        'id': '2657',
        'level': 2,
        'name': '齐齐哈尔',
        'code': '0,1,2568,2657,'
      },
      {
        'id': '2699',
        'level': 2,
        'name': '双鸭山',
        'code': '0,1,2568,2699,'
      },
      {
        'id': '2700',
        'level': 2,
        'name': '绥化',
        'code': '0,1,2568,2700,'
      },
      {
        'id': '2701',
        'level': 2,
        'name': '伊春',
        'code': '0,1,2568,2701,'
      }
    ],
    '湖北': [
      {
        'id': '2767',
        'level': 2,
        'name': '鄂州',
        'code': '0,1,2702,2767,'
      },
      {
        'id': '2927',
        'level': 2,
        'name': '恩施',
        'code': '0,1,2702,2927,'
      },
      {
        'id': '2782',
        'level': 2,
        'name': '黄冈',
        'code': '0,1,2702,2782,'
      },
      {
        'id': '2783',
        'level': 2,
        'name': '黄石',
        'code': '0,1,2702,2783,'
      },
      {
        'id': '2809',
        'level': 2,
        'name': '荆门',
        'code': '0,1,2702,2809,'
      },
      {
        'id': '2827',
        'level': 2,
        'name': '荆州',
        'code': '0,1,2702,2827,'
      },
      {
        'id': '2871',
        'level': 2,
        'name': '潜江',
        'code': '0,1,2702,2871,'
      },
      {
        'id': '2872',
        'level': 2,
        'name': '神农架林区',
        'code': '0,1,2702,2872,'
      },
      {
        'id': '2873',
        'level': 2,
        'name': '十堰',
        'code': '0,1,2702,2873,'
      },
      {
        'id': '2874',
        'level': 2,
        'name': '随州',
        'code': '0,1,2702,2874,'
      },
      {
        'id': '2884',
        'level': 2,
        'name': '天门',
        'code': '0,1,2702,2884,'
      },
      {
        'id': '2703',
        'level': 2,
        'name': '武汉',
        'code': '0,1,2702,2703,'
      },
      {
        'id': '2766',
        'level': 2,
        'name': '仙桃',
        'code': '0,1,2702,2766,'
      },
      {
        'id': '2885',
        'level': 2,
        'name': '咸宁',
        'code': '0,1,2702,2885,'
      },
      {
        'id': '2889',
        'level': 2,
        'name': '襄樊',
        'code': '0,1,2702,2889,'
      },
      {
        'id': '2890',
        'level': 2,
        'name': '孝感',
        'code': '0,1,2702,2890,'
      },
      {
        'id': '2891',
        'level': 2,
        'name': '宜昌',
        'code': '0,1,2702,2891,'
      }
    ],
    '吉林': [
      {
        'id': '3302',
        'level': 2,
        'name': '白城',
        'code': '0,1,3192,3302,'
      },
      {
        'id': '3303',
        'level': 2,
        'name': '白山',
        'code': '0,1,3192,3303,'
      },
      {
        'id': '3193',
        'level': 2,
        'name': '长春',
        'code': '0,1,3192,3193,'
      },
      {
        'id': '3258',
        'level': 2,
        'name': '吉林',
        'code': '0,1,3192,3258,'
      },
      {
        'id': '3304',
        'level': 2,
        'name': '辽源',
        'code': '0,1,3192,3304,'
      },
      {
        'id': '3305',
        'level': 2,
        'name': '四平',
        'code': '0,1,3192,3305,'
      },
      {
        'id': '3317',
        'level': 2,
        'name': '松原',
        'code': '0,1,3192,3317,'
      },
      {
        'id': '3318',
        'level': 2,
        'name': '通化',
        'code': '0,1,3192,3318,'
      },
      {
        'id': '3319',
        'level': 2,
        'name': '延边',
        'code': '0,1,3192,3319,'
      }
    ],
    '湖南': [
      {
        'id': '3036',
        'level': 2,
        'name': '常德',
        'code': '0,1,2928,3036,'
      },
      {
        'id': '2929',
        'level': 2,
        'name': '长沙',
        'code': '0,1,2928,2929,'
      },
      {
        'id': '3070',
        'level': 2,
        'name': '郴州',
        'code': '0,1,2928,3070,'
      },
      {
        'id': '3083',
        'level': 2,
        'name': '衡阳',
        'code': '0,1,2928,3083,'
      },
      {
        'id': '3121',
        'level': 2,
        'name': '怀化',
        'code': '0,1,2928,3121,'
      },
      {
        'id': '3125',
        'level': 2,
        'name': '娄底',
        'code': '0,1,2928,3125,'
      },
      {
        'id': '3126',
        'level': 2,
        'name': '邵阳',
        'code': '0,1,2928,3126,'
      },
      {
        'id': '3127',
        'level': 2,
        'name': '湘潭',
        'code': '0,1,2928,3127,'
      },
      {
        'id': '3128',
        'level': 2,
        'name': '湘西',
        'code': '0,1,2928,3128,'
      },
      {
        'id': '3129',
        'level': 2,
        'name': '益阳',
        'code': '0,1,2928,3129,'
      },
      {
        'id': '3130',
        'level': 2,
        'name': '永州',
        'code': '0,1,2928,3130,'
      },
      {
        'id': '3131',
        'level': 2,
        'name': '岳阳',
        'code': '0,1,2928,3131,'
      },
      {
        'id': '3035',
        'level': 2,
        'name': '张家界',
        'code': '0,1,2928,3035,'
      },
      {
        'id': '3160',
        'level': 2,
        'name': '株洲',
        'code': '0,1,2928,3160,'
      }
    ],
    '西藏': [
      {
        'id': '6187',
        'level': 2,
        'name': '阿里',
        'code': '0,1,6185,6187,'
      },
      {
        'id': '6188',
        'level': 2,
        'name': '昌都',
        'code': '0,1,6185,6188,'
      },
      {
        'id': '6186',
        'level': 2,
        'name': '拉萨',
        'code': '0,1,6185,6186,'
      },
      {
        'id': '6189',
        'level': 2,
        'name': '林芝',
        'code': '0,1,6185,6189,'
      },
      {
        'id': '6190',
        'level': 2,
        'name': '那曲',
        'code': '0,1,6185,6190,'
      },
      {
        'id': '6191',
        'level': 2,
        'name': '日喀则',
        'code': '0,1,6185,6191,'
      },
      {
        'id': '6192',
        'level': 2,
        'name': '山南',
        'code': '0,1,6185,6192,'
      }
    ],
    '四川': [
      {
        'id': '5995',
        'level': 2,
        'name': '阿坝',
        'code': '0,1,5841,5995,'
      },
      {
        'id': '5996',
        'level': 2,
        'name': '巴中',
        'code': '0,1,5841,5996,'
      },
      {
        'id': '5842',
        'level': 2,
        'name': '成都',
        'code': '0,1,5841,5842,'
      },
      {
        'id': '7238',
        'level': 2,
        'name': '西昌',
        'code': '0,1,5841,7238'
      },
      {
        'id': '5997',
        'level': 2,
        'name': '达州',
        'code': '0,1,5841,5997,'
      },
      {
        'id': '5998',
        'level': 2,
        'name': '德阳',
        'code': '0,1,5841,5998,'
      },
      {
        'id': '6038',
        'level': 2,
        'name': '甘孜',
        'code': '0,1,5841,6038,'
      },
      {
        'id': '6039',
        'level': 2,
        'name': '广安',
        'code': '0,1,5841,6039,'
      },
      {
        'id': '6040',
        'level': 2,
        'name': '广元',
        'code': '0,1,5841,6040,'
      },
      {
        'id': '6041',
        'level': 2,
        'name': '乐山',
        'code': '0,1,5841,6041,'
      },
      {
        'id': '6078',
        'level': 2,
        'name': '凉山',
        'code': '0,1,5841,6078,'
      },
      {
        'id': '6079',
        'level': 2,
        'name': '眉山',
        'code': '0,1,5841,6079,'
      },
      {
        'id': '5953',
        'level': 2,
        'name': '绵阳',
        'code': '0,1,5841,5953,'
      },
      {
        'id': '6080',
        'level': 2,
        'name': '南充',
        'code': '0,1,5841,6080,'
      },
      {
        'id': '6081',
        'level': 2,
        'name': '内江',
        'code': '0,1,5841,6081,'
      },
      {
        'id': '6082',
        'level': 2,
        'name': '攀枝花',
        'code': '0,1,5841,6082,'
      },
      {
        'id': '6083',
        'level': 2,
        'name': '遂宁',
        'code': '0,1,5841,6083,'
      },
      {
        'id': '6084',
        'level': 2,
        'name': '雅安',
        'code': '0,1,5841,6084,'
      },
      {
        'id': '6085',
        'level': 2,
        'name': '宜宾',
        'code': '0,1,5841,6085,'
      },
      {
        'id': '6086',
        'level': 2,
        'name': '资阳',
        'code': '0,1,5841,6086,'
      },
      {
        'id': '6087',
        'level': 2,
        'name': '自贡',
        'code': '0,1,5841,6087,'
      },
      {
        'id': '6088',
        'level': 2,
        'name': '泸州',
        'code': '0,1,5841,6088,'
      }
    ],
    '山西': [
      {
        'id': '5408',
        'level': 2,
        'name': '长治',
        'code': '0,1,5331,5408,'
      },
      {
        'id': '5409',
        'level': 2,
        'name': '大同',
        'code': '0,1,5331,5409,'
      },
      {
        'id': '5423',
        'level': 2,
        'name': '晋城',
        'code': '0,1,5331,5423,'
      },
      {
        'id': '5434',
        'level': 2,
        'name': '晋中',
        'code': '0,1,5331,5434,'
      },
      {
        'id': '5446',
        'level': 2,
        'name': '临汾',
        'code': '0,1,5331,5446,'
      },
      {
        'id': '5496',
        'level': 2,
        'name': '吕梁',
        'code': '0,1,5331,5496,'
      },
      {
        'id': '5497',
        'level': 2,
        'name': '朔州',
        'code': '0,1,5331,5497,'
      },
      {
        'id': '5332',
        'level': 2,
        'name': '太原',
        'code': '0,1,5331,5332,'
      },
      {
        'id': '5498',
        'level': 2,
        'name': '忻州',
        'code': '0,1,5331,5498,'
      },
      {
        'id': '5499',
        'level': 2,
        'name': '阳泉',
        'code': '0,1,5331,5499,'
      },
      {
        'id': '5500',
        'level': 2,
        'name': '运城',
        'code': '0,1,5331,5500,'
      }
    ],
    '陕西': [
      {
        'id': '5621',
        'level': 2,
        'name': '安康',
        'code': '0,1,5513,5621,'
      },
      {
        'id': '5622',
        'level': 2,
        'name': '宝鸡',
        'code': '0,1,5513,5622,'
      },
      {
        'id': '5623',
        'level': 2,
        'name': '汉中',
        'code': '0,1,5513,5623,'
      },
      {
        'id': '5624',
        'level': 2,
        'name': '商洛',
        'code': '0,1,5513,5624,'
      },
      {
        'id': '5625',
        'level': 2,
        'name': '铜川',
        'code': '0,1,5513,5625,'
      },
      {
        'id': '5626',
        'level': 2,
        'name': '渭南',
        'code': '0,1,5513,5626,'
      },
      {
        'id': '5514',
        'level': 2,
        'name': '西安',
        'code': '0,1,5513,5514,'
      },
      {
        'id': '5627',
        'level': 2,
        'name': '咸阳',
        'code': '0,1,5513,5627,'
      },
      {
        'id': '5640',
        'level': 2,
        'name': '延安',
        'code': '0,1,5513,5640,'
      },
      {
        'id': '5641',
        'level': 2,
        'name': '榆林',
        'code': '0,1,5513,5641,'
      }
    ],
    '台湾': [
      {
        'id': '7233',
        'level': 2,
        'name': '台湾',
        'code': '0,1,7232,7233,'
      }
    ],
    '山东': [
      {
        'id': '4770',
        'level': 2,
        'name': '滨州',
        'code': '0,1,4669,4770,'
      },
      {
        'id': '4777',
        'level': 2,
        'name': '德州',
        'code': '0,1,4669,4777,'
      },
      {
        'id': '4778',
        'level': 2,
        'name': '东营',
        'code': '0,1,4669,4778,'
      },
      {
        'id': '4817',
        'level': 2,
        'name': '菏泽',
        'code': '0,1,4669,4817,'
      },
      {
        'id': '4670',
        'level': 2,
        'name': '济南',
        'code': '0,1,4669,4670,'
      },
      {
        'id': '4818',
        'level': 2,
        'name': '济宁',
        'code': '0,1,4669,4818,'
      },
      {
        'id': '4891',
        'level': 2,
        'name': '莱芜',
        'code': '0,1,4669,4891,'
      },
      {
        'id': '4892',
        'level': 2,
        'name': '聊城',
        'code': '0,1,4669,4892,'
      },
      {
        'id': '4924',
        'level': 2,
        'name': '临沂',
        'code': '0,1,4669,4924,'
      },
      {
        'id': '4708',
        'level': 2,
        'name': '青岛',
        'code': '0,1,4669,4708,'
      },
      {
        'id': '4984',
        'level': 2,
        'name': '日照',
        'code': '0,1,4669,4984,'
      },
      {
        'id': '4998',
        'level': 2,
        'name': '泰安',
        'code': '0,1,4669,4998,'
      },
      {
        'id': '5051',
        'level': 2,
        'name': '威海',
        'code': '0,1,4669,5051,'
      },
      {
        'id': '5130',
        'level': 2,
        'name': '潍坊',
        'code': '0,1,4669,5130,'
      },
      {
        'id': '5193',
        'level': 2,
        'name': '烟台',
        'code': '0,1,4669,5193,'
      },
      {
        'id': '5259',
        'level': 2,
        'name': '枣庄',
        'code': '0,1,4669,5259,'
      },
      {
        'id': '5288',
        'level': 2,
        'name': '淄博',
        'code': '0,1,4669,5288,'
      }
    ],
    '宁夏': [
      {
        'id': '4627',
        'level': 2,
        'name': '固原',
        'code': '0,1,4589,4627,'
      },
      {
        'id': '4628',
        'level': 2,
        'name': '石嘴山',
        'code': '0,1,4589,4628,'
      },
      {
        'id': '4629',
        'level': 2,
        'name': '吴忠',
        'code': '0,1,4589,4629,'
      },
      {
        'id': '4590',
        'level': 2,
        'name': '银川',
        'code': '0,1,4589,4590,'
      },
      {
        'id': '4630',
        'level': 2,
        'name': '中卫',
        'code': '0,1,4589,4630,'
      }
    ],
    '青海': [
      {
        'id': '4662',
        'level': 2,
        'name': '果洛',
        'code': '0,1,4631,4662,'
      },
      {
        'id': '4663',
        'level': 2,
        'name': '海北',
        'code': '0,1,4631,4663,'
      },
      {
        'id': '4664',
        'level': 2,
        'name': '海东',
        'code': '0,1,4631,4664,'
      },
      {
        'id': '4665',
        'level': 2,
        'name': '海南藏族自治州',
        'code': '0,1,4631,4665,'
      },
      {
        'id': '4666',
        'level': 2,
        'name': '海西',
        'code': '0,1,4631,4666,'
      },
      {
        'id': '4667',
        'level': 2,
        'name': '黄南',
        'code': '0,1,4631,4667,'
      },
      {
        'id': '4632',
        'level': 2,
        'name': '西宁',
        'code': '0,1,4631,4632,'
      },
      {
        'id': '4668',
        'level': 2,
        'name': '玉树',
        'code': '0,1,4631,4668,'
      }
    ],
    '香港': [
      {
        'id': '7157',
        'level': 3,
        'name': '香港岛',
        'code': '0,1,7155,7156,7157,'
      },
      {
        'id': '7176',
        'level': 3,
        'name': '离岛',
        'code': '0,1,7155,7156,7176,'
      },
      {
        'id': '7183',
        'level': 3,
        'name': '九龙',
        'code': '0,1,7155,7156,7183,'
      },
      {
        'id': '7201',
        'level': 3,
        'name': '新界',
        'code': '0,1,7155,7156,7201,'
      }
    ],
    '新疆': [
      {
        'id': '7244',
        'level': 2,
        'name': '塔城',
        'code': '0,1,6193,7244,'
      },
      {
        'id': '6235',
        'level': 2,
        'name': '阿克苏',
        'code': '0,1,6193,6235,'
      },
      {
        'id': '6236',
        'level': 2,
        'name': '阿拉尔',
        'code': '0,1,6193,6236,'
      },
      {
        'id': '6237',
        'level': 2,
        'name': '巴音郭楞',
        'code': '0,1,6193,6237,'
      },
      {
        'id': '6238',
        'level': 2,
        'name': '博尔塔拉',
        'code': '0,1,6193,6238,'
      },
      {
        'id': '6239',
        'level': 2,
        'name': '昌吉',
        'code': '0,1,6193,6239,'
      },
      {
        'id': '6240',
        'level': 2,
        'name': '哈密',
        'code': '0,1,6193,6240,'
      },
      {
        'id': '6241',
        'level': 2,
        'name': '和田',
        'code': '0,1,6193,6241,'
      },
      {
        'id': '6242',
        'level': 2,
        'name': '喀什',
        'code': '0,1,6193,6242,'
      },
      {
        'id': '6243',
        'level': 2,
        'name': '克拉玛依',
        'code': '0,1,6193,6243,'
      },
      {
        'id': '6244',
        'level': 2,
        'name': '克孜勒苏',
        'code': '0,1,6193,6244,'
      },
      {
        'id': '6245',
        'level': 2,
        'name': '石河子',
        'code': '0,1,6193,6245,'
      },
      {
        'id': '6246',
        'level': 2,
        'name': '图木舒克',
        'code': '0,1,6193,6246,'
      },
      {
        'id': '6247',
        'level': 2,
        'name': '吐鲁番',
        'code': '0,1,6193,6247,'
      },
      {
        'id': '6194',
        'level': 2,
        'name': '乌鲁木齐',
        'code': '0,1,6193,6194,'
      },
      {
        'id': '6248',
        'level': 2,
        'name': '五家渠',
        'code': '0,1,6193,6248,'
      },
      {
        'id': '6249',
        'level': 2,
        'name': '伊犁',
        'code': '0,1,6193,6249,'
      }
    ],
    '云南': [
      {
        'id': '6347',
        'level': 2,
        'name': '保山',
        'code': '0,1,6250,6347,'
      },
      {
        'id': '6348',
        'level': 2,
        'name': '楚雄',
        'code': '0,1,6250,6348,'
      },
      {
        'id': '6349',
        'level': 2,
        'name': '大理',
        'code': '0,1,6250,6349,'
      },
      {
        'id': '6350',
        'level': 2,
        'name': '德宏',
        'code': '0,1,6250,6350,'
      },
      {
        'id': '6351',
        'level': 2,
        'name': '迪庆',
        'code': '0,1,6250,6351,'
      },
      {
        'id': '6352',
        'level': 2,
        'name': '红河',
        'code': '0,1,6250,6352,'
      },
      {
        'id': '6251',
        'level': 2,
        'name': '昆明',
        'code': '0,1,6250,6251,'
      },
      {
        'id': '6338',
        'level': 2,
        'name': '丽江',
        'code': '0,1,6250,6338,'
      },
      {
        'id': '6353',
        'level': 2,
        'name': '临沧',
        'code': '0,1,6250,6353,'
      },
      {
        'id': '6336',
        'level': 2,
        'name': '怒江',
        'code': '0,1,6250,6336,'
      },
      {
        'id': '6337',
        'level': 2,
        'name': '普洱',
        'code': '0,1,6250,6337,'
      },
      {
        'id': '6354',
        'level': 2,
        'name': '曲靖',
        'code': '0,1,6250,6354,'
      },
      {
        'id': '6355',
        'level': 2,
        'name': '文山',
        'code': '0,1,6250,6355,'
      },
      {
        'id': '6356',
        'level': 2,
        'name': '西双版纳',
        'code': '0,1,6250,6356,'
      },
      {
        'id': '6357',
        'level': 2,
        'name': '玉溪',
        'code': '0,1,6250,6357,'
      },
      {
        'id': '6358',
        'level': 2,
        'name': '昭通',
        'code': '0,1,6250,6358,'
      }
    ],
    '浙江': [
      {
        'id': '6360',
        'level': 2,
        'name': '杭州',
        'code': '0,1,6359,6360,'
      },
      {
        'id': '6434',
        'level': 2,
        'name': '湖州',
        'code': '0,1,6359,6434,'
      },
      {
        'id': '6495',
        'level': 2,
        'name': '嘉兴',
        'code': '0,1,6359,6495,'
      },
      {
        'id': '6562',
        'level': 2,
        'name': '金华',
        'code': '0,1,6359,6562,'
      },
      {
        'id': '6613',
        'level': 2,
        'name': '丽水',
        'code': '0,1,6359,6613,'
      },
      {
        'id': '6640',
        'level': 2,
        'name': '宁波',
        'code': '0,1,6359,6640,'
      },
      {
        'id': '6701',
        'level': 2,
        'name': '绍兴',
        'code': '0,1,6359,6701,'
      },
      {
        'id': '6796',
        'level': 2,
        'name': '台州',
        'code': '0,1,6359,6796,'
      },
      {
        'id': '6852',
        'level': 2,
        'name': '温州',
        'code': '0,1,6359,6852,'
      },
      {
        'id': '6945',
        'level': 2,
        'name': '舟山',
        'code': '0,1,6359,6945,'
      },
      {
        'id': '6989',
        'level': 2,
        'name': '衢州',
        'code': '0,1,6359,6989,'
      }
    ]
  }
  return list
}



// WEBPACK FOOTER //
// ./src/api/city.js